// extracted by mini-css-extract-plugin
export default {"editor":"editor___e53b6658240dcda260a8"};